import { createContext, useContext, useState } from "react";

const CurrencyContext = createContext({
  currency: "usd",
  setCurrency: () => {},
  format: () => "",
});

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(
    () => localStorage.getItem("arcana_currency") || "usd"
  );

  const update = (cur) => {
    setCurrency(cur);
    localStorage.setItem("arcana_currency", cur);
  };

  const format = (usd, inr) =>
    currency === "inr"
      ? `₹${Number(inr).toLocaleString("en-IN")}`
      : `$${Number(usd).toLocaleString("en-US")}`;

  const formatAlt = (usd, inr) =>
    currency === "inr"
      ? `$${Number(usd).toLocaleString("en-US")}`
      : `₹${Number(inr).toLocaleString("en-IN")}`;

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency: update, format, formatAlt }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
